import { createSlice } from '@reduxjs/toolkit';
import {RootState} from "../store";

type SubMenuItemType = {
    title: string,
    link: string,
    count: number
}

type MenuItemType = {
    title: string,
    link: string,
    count: number,
    items: SubMenuItemType[]
}

type MenuType = {
    title: string,
    items: MenuItemType[]
}

const initialState: MenuType = {
    title: "",
    items: []
}

export const menuSlice = createSlice({
    name: 'menu',
    initialState: initialState,
    reducers: {
        setTitle(state, action) {
            state.title = action.payload;
        },
        addItem(state, action) {
            state.items.push(action.payload);
        },
        resetItems(state) {
            state.items = [];
        },
        resetMenu(state) {
            state.title = "";
            state.items = [];
        }
    }
})

export const menuSelector = (state: RootState) => state.menu;
export const {addItem, resetItems, setTitle, resetMenu} = menuSlice.actions;
export default menuSlice.reducer;
